<div class=" mt-4">
  <section class="my-4">
    <div class="scrollmenu">
      <a  class="active menu" [routerLink]="['/PayOut/managePayoutAccountdetails']">Payout Security</a>
      <a [routerLink]="['/PayOut/PayoutSecurityTransactions']">Payout Security Transactions</a>
    </div>
  </section>
  <section>

    <div class="row mb-3">
      <div class="col-md-12">
        <div class="float-right">
          <!-- <a href="" class="back-tour mr-3" type="a" data-toggle="modal" data-target="#exampleModalCenter">Need Help ?
            Take a Tour <i class="far fa-lightbulb"></i></a> -->
          <button class="dash-btns mr-3" type="button" id="NewPrepaidCard" [routerLink]="['/PayOut/PayoutAccountdetails']"
            color="primary" matTooltip="New PrepaidCard" *ngIf="NewAccount"> Payout Security</button>

          <div class="dropdown d-inline">
            <button class="dash-btns mr-3" type="button" data-bs-toggle="dropdown">Download &nbsp;<i
                class="fas fa-caret-down"></i>
            </button>
            <ul class="dropdown-menu text-center">
              <li><a  id="btnExportBatch" (click)="readAndExportTransactionData()">Excel</a></li>
            </ul>
          </div>



          <button class="btn dash-btns" type="button" id="filtering" (click)="filters()"> <i class="fa fa-filter" aria-hidden="true"></i> Filter</button>


        </div>
      </div>
      <div class="col-md-12">
        <small class=" font-16 gary-t ">Currently we are displaying last 7 days report. For more details please click onFilter</small>
      </div>
    </div>
<!-- //filter -->


<div class="row  my-4" *ngIf="filtering">
  <div class="col-md-12">
    <div class="card-1 p-4">
      <h4 class="font-26 gary-t">Filter Your Result</h4>
      <p>Please Fill the details to filter your result</p>
      <div class="col-md-12">
        <!-- filtering starts -->
        <form>
          <div class="row m-0">
            <div class="col-md-3 mt-4">

              <div class="form-group">
                <label class="customlabel">Date</label>
                <div class="selectcustom mb-0">
                  <ngx-select [items]="Range" id="daterange" placeholder="Today" [formControl]="daterange" required
                  (ngModelChange)="checkRangeType()">
                </ngx-select>
                </div>

              </div>
            </div>
            <div class="col-md-3 mt-4" *ngIf="Rfromdate">


              <div class="form-group">
                <label class="customlabel">From Date</label>
                <input class="formcontrol-user1 form-control" type="date" placeholder="From Date" id="fromdate"
                  [formControl]="fromdate" (change)="checkDateRange()">
              </div>

            </div>
            <div class="col-md-3 mt-4" *ngIf="Rfromdate">

              <div class="form-group">
                <label class="customlabel">To Date</label>
                <input class="formcontrol-user1 form-control" type="date" placeholder="To Date" id="todate"
                  [formControl]="todate" (change)="checkDateRange()">
              </div>
              <span class="text-danger" *ngIf="isStartDateGreaterthenEndDate">From Date Should not be greater than To
                Date</span>
            </div>

            <div class="col-md-3  mt-4">

              <div class="form-group">
                <label class="customlabel">Customer AccountId</label>
                <input class="formcontrol-user1 form-control" type="text" placeholder="Customer ID" id="CustomerId"
                  [formControl]="CustomerId">
              </div>
            </div>
            <div class="col-md-3  mt-4">

              <div class="form-group">
                <label class="customlabel">Account Number</label>
                <input class="formcontrol-user1 form-control" type="text" placeholder="Account Number" id="AccountNumber"
                  [formControl]="AccountNumber">
              </div>
            </div>

            <div class="col-md-3  mt-4">

              <div class="form-group">
                <label class="customlabel">IFSCCode</label>
                <input class="formcontrol-user1 form-control" type="text" placeholder="IFSCCode" id="IFSCCode"
                  [formControl]="IFSCCode">
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="col-md-12 text-right">
        <div class="text-right mt-3" *ngIf="!isCustomDateSelected">
          <button class="dash-btns" type="button" id="filtering" (click)="selectedaterange()"
            matTooltip="New Sale Transaction"> Search</button>
        </div>

        <div class="text-right mt-3" *ngIf="isCustomDateSelected">
          <button class="dash-btns" type="button" id="filtering" [disabled]="!isreportsbtnActive" (click)="search()"
            matTooltip="New Sale Transaction"> Search</button>
        </div>
      </div>
    </div>
  </div>
</div>






    <div class="row">
      <div class="col-md-12">
        <ngx-datatable #table class='bootstrap no-detail-row' (columnMode)="'Force'" [footerHeight]="50"
          [rowHeight]="'auto'"[columnMode]="'force'" [scrollbarH]="true" [limit]="10" [rows]="Accountdetails">
          <ngx-datatable-column name="Action" [width]="200">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <a class=" edit" [routerLink]="['/PayOut/ViewPayoutAccountdetails',{Id: row.Id}]" data-toggle="tooltip"
                data-placement="top" title="View">
                <img src="./assets/ViewDetails.svg">
              </a>
              <!-- <a class=" edit pl-3 d-inline" [routerLink]="['/PayOut/PayoutAccountdetails',{Id: row.Id}]"
                data-toggle="tooltip" data-placement="top" title="Edit"> <em class="fas mr-2 fa-edit"></em>
              </a>
              <a class="edit pl-3 d-inline" [routerLink]="['/PayOut/ViewPayoutAccountdetails',{Id: row.Id}]"
              data-toggle="tooltip" data-placement="top" title="Delete">
              <em class="far fa-trash-alt mr-2"></em>
              </a> -->
            </ng-template>
          </ngx-datatable-column>

          <!-- [width]="200" -->
          <ngx-datatable-column name="AccountNumber" [width]="200">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.AccountNumber}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="IFSCCode">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.IFSCCode}} </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Customer AccountId">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.CustomerAccountId}} </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Status">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span class="status-warning-btn" *ngIf="row.status==0">
                Pending
              </span>
              <span class="status-danger-btn" *ngIf="row.status==2">
                Declined
              </span>
              <span class="status-approved-btn" *ngIf="row.status==1">
                Approved
              </span>

            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="UpdatedDateTime">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class="robot font400">{{row.UpdatedDateTime | date:'d/M/yy, h:mm a' }}</div>
            </ng-template>

          </ngx-datatable-column>
          <!-- <ngx-datatable-column name="Name">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.FirstName}}
            </ng-template>
          </ngx-datatable-column> -->

          <!-- <ngx-datatable-column name="City">
          <ng-template let-row="row" ngx-datatable-cell-template><div class=" robot font400">{{row.Phone}}</div></ng-template>
        </ngx-datatable-column> -->

          <!-- <ngx-datatable-column name="Mobile No">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class=" robot font400">{{row.MobileNo}}</div>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Email">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class=" robot font400">{{row.Email}}</div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Date Time">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class=" robot font400">{{row.UpdatedDatetime | date:'d/M/yy, h:mm a' }}</div>
            </ng-template>
          </ngx-datatable-column> -->



        </ngx-datatable>
      </div>
    </div>
  </section>
</div>


